import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UploadForm } from "@/components/upload/UploadForm";
import { useToast } from "@/components/ui/use-toast";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";

export default function UploadTemplate() {
  const [isUploading, setIsUploading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleUploadComplete = () => {
    toast({
      title: "Success",
      description: "Template uploaded successfully and sent for review.",
    });
    navigate("/templates");
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <Button 
          variant="outline" 
          onClick={() => navigate("/templates")}
          className="mb-4"
        >
          <ChevronLeft className="h-4 w-4 mr-2" />
          Back to Templates
        </Button>
        <h1 className="text-2xl font-bold">Upload New Template</h1>
        <p className="text-gray-500 mt-2">
          Upload a template file to be processed and reviewed by our team.
        </p>
      </div>

      <div className="max-w-2xl">
        <UploadForm 
          onFileSelect={() => {}}
          isUploading={isUploading}
          isProcessing={isProcessing}
          onUploadComplete={handleUploadComplete}
        />
      </div>
    </div>
  );
} 